import { inmunetApi } from '../../../api';
import { login, logout, checking } from './authSlice';
import { successNotification, dangerNotification } from '../ui';
import { clearNotifications } from '../ui/uiSlice';

export const startLogin = (email, password) => {
    return async(dispatch) => {

        dispatch(checking());

        try {

            const { data } = await inmunetApi.post('/authAdmin/login', { email, password });

            localStorage.setItem('token', data.token);

            dispatch(login(data));
            dispatch(clearNotifications());
            dispatch(successNotification('Sesión iniciada'));

        } catch (error) {

            localStorage.removeItem('token');
            if (typeof error.response !== 'undefined' && typeof error.response.data !== 'undefined' && typeof error.response.data.msg !== 'undefined') {

                dispatch(logout(error.response.data));
                dispatch(dangerNotification(error.response.data.msg));

            } else {

                dispatch(logout({ msg: 'Error al procesar la petición, intenta nuevamente.' }));
                dispatch(dangerNotification('Error al procesar la petición, intenta nuevamente.'));

            }

        }

    }
}

export const startAutoLogin = () => {
    return async(dispatch) => {

        const token = localStorage.getItem('token');
        if (!token) return dispatch(logout());

        try {

            const { data } = await inmunetApi.get('/authAdmin/auto-login');

            localStorage.setItem('token', data.token);

            dispatch(login(data));

        } catch (error) {

            localStorage.removeItem('token');
            dispatch(logout());

        }

    }
}

export const startLogout = () => {
    return async(dispatch) => {

        try {

            await inmunetApi.post('/authAdmin/logout');

            localStorage.removeItem('token');
            dispatch(logout());
            dispatch(clearNotifications());
            dispatch(successNotification('Sesión cerrada'));

        } catch (error) {

            localStorage.removeItem('token');
            dispatch(logout());
            dispatch(clearNotifications());
            dispatch(successNotification('Sesión cerrada'));

        }

    }
}